<template>
  <div
    v-if="canEmailBol"
    class="document-email-checkbox-container checkbox-container flex align-items-center"
  >
    <Checkbox
      v-model="internalEmailBolSelected"
      :input-id="t('documents.billOfLading')"
      binary
    />
    <div class="document-details">
      <label class="document-name" :for="t('documents.billOfLading')">
        {{ t('documents.billOfLading') }}
      </label>
    </div>
  </div>
  <div
    v-for="document in documents"
    :key="document.id"
    class="document-email-checkbox-container checkbox-container flex align-items-center"
  >
    <Checkbox
      v-model="internalSelectedDocuments"
      :input-id="document.documentName"
      :name="document.fileName"
      :value="document"
    />
    <div class="document-details">
      <label class="document-name" :for="document.documentName">
        {{ getDocumentLabelPrefix(document) }}
        {{ document.documentName }}
      </label>
      <div class="document-type-chips flex">
        <RygenChip
          v-for="(documentType, index) in document.types"
          :key="index"
          :label="translateEnum(documentType, 'CorsairDocumentType')"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { DocumentParentEntity } from '@rygen/rygen-ui/model';

import { RelatedDocument, SignedDocument } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';
import Checkbox from 'primevue/checkbox';

const internalSelectedDocuments = defineModel('modelValue', {
  type: Array as PropType<(SignedDocument | RelatedDocument)[]>,
  default: () => [],
});

const internalEmailBolSelected = defineModel('emailBolSelected', {
  type: Boolean,
  default: false,
});

const props = defineProps({
  documents: {
    type: Array as PropType<(SignedDocument | RelatedDocument)[]>,
    required: true,
  },
  canEmailBol: {
    type: Boolean,
    default: false,
  },
});
const { documents, canEmailBol } = toRefs(props);
const { t } = useI18n();

const getDocumentLabelPrefix = (
  document: SignedDocument | RelatedDocument,
): string => {
  if (document instanceof SignedDocument) {
    return '';
  }
  return document.parentEntity === DocumentParentEntity.SHIPMENT
    ? t('shipments.shipmentNumParam', { param: document.parentId })
    : document.parentEntity === DocumentParentEntity.ORDER
      ? t('orders.orderNumParam', { param: document.parentId })
      : '';
};
</script>
